import { useCallback, useContext, useEffect, useState } from "react";
import { NaviItem } from "../../types/naviItem";
import Logo from "../molecules/ImageLink";
import NaviMenu from "../molecules/NaviMenu";
import SearchForm from "../molecules/SearchForm";
import STHeader from "../../assets/styles/organisms/header.module.scss";
import STUtils from "../../assets/styles/utility.module.scss";

import PAGE_CONFIG from "../../config/page";
import DrawerMenuButton from "../atoms/DrawerMenuButton";
import DrawerMenu from "./DrawerMenu";

import SvgPointApplication from "../atoms/icons/PointApplication";
import SvgPointHistory from "../atoms/icons/PointHistory";
import SvgGift from "../atoms/icons/Gift";
import SvgArticle from "../atoms/icons/Article";
import getImageUrl from "../../utils/getImageUrl";
import { routes } from "../../router/Router";
import { Link, useHistory } from "react-router-dom";
import { SiteContext } from "../../providers/SiteProvider";
import {
  fetchMenuSettings,
  TApiMenuSettingsResult,
} from "../../utils/api/fetchMenuSettings";
import TApiResult from "../../types/api/TApiResult";
import { Person } from "@material-ui/icons";
import { Box, makeStyles, Typography } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  myPage: {
    fontWeight: 700,
    fontSize: "14px",
  },
}));

type Props = {
  login: boolean;
  subdomain: string;
};

const HEADER_LOCATION_ID = 14;

const Header: React.FC<Props> = (props: Props) => {
  const classes = useStyles();
  const site = useContext(SiteContext);

  // const deFaultNaviItems: NaviItem[] = [
  //   {
  //     id: 1,
  //     locationId: HEADER_LOCATION_ID,
  //     order: 1,
  //     name: "MYページ",
  //     url: routes.top.path,
  //     icon: <SvgMypage viewBox="-1 -3 24 24" height={16} width={16} />,
  //   },
  //   {
  //     id: 2,
  //     locationId: HEADER_LOCATION_ID,
  //     order: 2,
  //     name: site.isPoint ? "ポイント申請" : "リワード申請",
  //     url: routes.pointRequest.path,
  //     icon: <SvgPointApplication viewBox="-4 -4 33 33" height={16} width={16} />,
  //   },
  //   {
  //     id: 3,
  //     locationId: HEADER_LOCATION_ID,
  //     order: 3,
  //     name: site.isPoint ? "ポイント履歴" : "リワード履歴",
  //     url: routes.pointHistory.path,
  //     icon: <SvgPointHistory viewBox="1 -2 24 24" height={16} width={16} />,
  //   },
  //   {
  //     id: 4,
  //     locationId: HEADER_LOCATION_ID,
  //     name: "会員優待特典について",
  //     order: 4,
  //     url: routes.memberPremium.path,
  //     icon: <SvgGift viewBox="-3 -2 24 24" height={16} width={16} />,
  //   },
  //   {
  //     id: 5,
  //     locationId: HEADER_LOCATION_ID,
  //     order: 5,
  //     name: "お知らせ・記事",
  //     url: routes.informations.path,
  //     icon: <SvgArticle viewBox="-3 -1 24 24" height={16} width={16} />,
  //   },
  // ];

  const history = useHistory();
  const [isHeaderShown, setIsHeaderShown] = useState(true);
  const [lastPosition, setLastPosition] = useState(0);
  const headerHeight = 20;
  const [naviItems, setNaviItems] = useState<NaviItem[]>([]);
  const scrollEvent = useCallback(() => {
    const offset = window.pageYOffset;

    if (offset > headerHeight) {
      setIsHeaderShown(false);
    } else {
      setIsHeaderShown(true);
    }

    if (offset < lastPosition) {
      setIsHeaderShown(true);
    }

    setLastPosition(offset);
  }, [lastPosition]);

  useEffect(() => {
    window.addEventListener("scroll", scrollEvent);

    return () => {
      window.removeEventListener("scroll", scrollEvent);
    };
  }, [scrollEvent]);
  /*
  const [scrolled, setScrolled] = useState(false);

  
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      setScrolled(currentScrollY > 10);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => window.removeEventListener("scroll", handleScroll);
  }, [scrolled]);
  */

  const [isOpen, setIsOpen] = useState(false);

  const executeSearch = (query: string) => {
    history.push(`${routes.informations.path}?title=${query}`);
  };

  useEffect(() => {
    fetchMenuSettings(HEADER_LOCATION_ID).then(
      (res: TApiResult & TApiMenuSettingsResult) => {
        if (!res.isSuccess || !res.result) return;
        const naviItems = res.result.map((res) => {
          return {
            id: res.id,
            siteId: res.site_id,
            locationId: res.location_id,
            order: res.order,
            icon: res.icon,
            url: res.url,
            name: res.name,
            locationName: res.location_name,
          };
        });
        const newNaviItems = naviItems.filter((v) => Boolean(v.name));
        newNaviItems.sort((x, y) => {
          return x.order - y.order;
        });
        setNaviItems(newNaviItems);
      }
    );
  }, []);

  return (
    <header
      className={isHeaderShown ? STHeader.header : STHeader.header__hide}
      role="banner"
    >
      <div className={`${STHeader.header_nav} ${STUtils.container_large}`}>
        <div className={STHeader.header_logo}>
          <Logo
            linkUrl={routes.top.path}
            imageUrl={getImageUrl(
              props.subdomain,
              PAGE_CONFIG.IMAGE_URL_PATH.SITE,
              PAGE_CONFIG.LOGO
            )}
            className={STHeader.header_logo_img}
            alt={props.subdomain}
          />
        </div>
        {props.login && (
          <>
            <div className={`${STUtils.dn_sp} ${STHeader.header_nav_wrap}`}>
              <NaviMenu
                naviItems={naviItems}
                className={STHeader.header_nav_menu}
              />
              <SearchForm
                className={STHeader.header_nav_search}
                executeSearch={executeSearch}
              />
            </div>
            <div className={STUtils.dn_pc}>
              <SearchForm
                className={STHeader.header_nav_search}
                executeSearch={executeSearch}
              />
              <DrawerMenuButton
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                subdomain={props.subdomain}
              />
              <DrawerMenu
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                subdomain={props.subdomain}
                imageUrl={getImageUrl(
                  props.subdomain,
                  PAGE_CONFIG.IMAGE_URL_PATH.SITE,
                  PAGE_CONFIG.LOGO
                )}
                naviItems={naviItems}
              />
            </div>
          </>
        )}
      </div>
    </header>
  );
};

export default Header;
